import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { generateClient } from 'aws-amplify/data'
import { AGREEMENT_MESSAGE } from '@utils/agreement'
import type { Schema } from '@/../../amplify/data/resource'

const client = generateClient<Schema>()

export const useAgreementModalLogic = () => {
	const authStore = useAuthStore()
	const agreed = ref(false)
	const loading = ref(false)
	const error = ref<string | null>(null)

	const signAgreement = async () => {
		if (!agreed.value) {
			error.value = 'You must agree to the terms and conditions'
			return
		}

		loading.value = true
		error.value = null

		try {
			const userId = authStore.user?.id
			if (!userId) {
				throw new Error('User ID not found')
			}

			// The signed log entry is the evidentiary record — persist the exact text
			// the admin was shown, not a synthesized summary.
			const result = await client.mutations.signAgreement({
				userId,
				agreementMessage: AGREEMENT_MESSAGE
			})

			if (result.data?.success) {
				await authStore.refreshAuthToken()
        // redirect user home, otherwise user hangs in the generic sign-out block
        //  using redirect over router to ensure tokens are cleanly propagated
        window.location.assign('/home')
			} else {
				throw new Error(result.data?.error || 'Failed to sign agreement')
			}
		} catch (err: any) {
			console.error('Error signing agreement:', err)
			error.value = err.message || 'Failed to sign agreement'
		} finally {
			loading.value = false
		}
	}

	return {
		agreed,
		loading,
		error,
		signAgreement
	}
}

